export enum dataTypesEnum {
  UNION = 'union',
  JOIN = 'join',
}
export enum mappingFunctionDataTypeEnum {
  firstSourceUnion = 'firstSourceUnion',
}
